import { render, staticRenderFns } from "./package.vue?vue&type=template&id=b9690bc8&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"
import style0 from "./package.vue?vue&type=style&index=0&id=b9690bc8&prod&lang=scss"
import style1 from "./package.vue?vue&type=style&index=1&id=b9690bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9690bc8",
  null
  
)

export default component.exports